import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class Modal extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPressed.bind(this), false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPressed.bind(this), false);
  }

  handleKeyPressed(event) {
    if (event.keyCode === 27) {
      this.props.onClose();
    }
  }

  render() {
    const { rootClassname, isOpened, onClose } = this.props;
    const finalRootClass = classnames(style.root, rootClassname);
    return (
      <Fragment>
        {isOpened && (
          <div>
            <div className={finalRootClass}>{this.props.children}</div>
            <div className={style.overlay} onClick={onClose} />
          </div>
        )}
      </Fragment>
    );
  }
}

Modal.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rootClassname: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Modal/index.js